import React from 'react'
import { useSelector } from 'react-redux'
import Factor from './Factor'
import './Factors.css'
import i18n from '../../../i18n'
import CompText from '../Compliance/CompText'

const Factors = () => {
  let data = useSelector(state => state.fundData.data)
  data = data.map((x) => {
    if (x.multifactorTilts && x.multifactorTilts.length === 0) {
      x.multifactorTilts = null;
    }
    return x;
  });

  const dataFilter = data.filter(x => x.aggregateFundamentals !== null);
  const hasFactorData = dataFilter.length > 0  

  //if we are done fetching data and current loaded data has no factors
  if (!hasFactorData) {
    return (
      <div>
        <div className='noData'>{i18n.t('no-data')} </div>
        <div style={{ marginBottom: '65px' }} />
        <CompText pane='Factors' />
      </div>
    )
  }

  return (
    <div className='fund-char-factors'>
      <div className='row'>
        <Factor name='Correlation' data={data} />
        <Factor name='Momentum' data={data} />
        <Factor name='Quality' data={data} />
        <Factor name='Value' data={data} />
      </div>
      <div className='factorCompliance'>{i18n.t('comp-factors')}</div>
      <CompText pane='Factors' />
    </div>
  )
}

export default Factors
